import React, { useState, useEffect, useRef } from "react";
import { useGlobalState } from "../contexts/GlobalStateContext.js";
import { useNavigate } from "react-router-dom";
import Information from "./Information.jsx";
const LoginModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const {
    globalState,
    setUser,
    setAuth,
    setShowLogin,
    setShowSignUp,
    setShowVerify,
    setSessionExpired,
    setGlobalState,
    showAnotherSignInModal,
  } = useGlobalState();
  const [email, setEmail] = useState(""); // Ensure initial value is an empty string
  const [password, setPassword] = useState(""); // Ensure initial value is an empty string
  const [isLoading, setIsLoading] = useState(false);
  const [camp, setCamp] = useState("");
  const [sectorUnit, setSectorUnit] = useState("");
  const [hutNumber, setHutNumber] = useState("");
  const [signUpPassword, setSignUpPassword] = useState(""); // Ensure initial value is an empty string
  const [retypedPassword, setRetypedPassword] = useState(""); // Ensure initial value is an empty string
  const [country, setCountry] = useState(""); // Ensure initial value is an empty string
  const [signUpEmail, setSignUpEmail] = useState(""); // Ensure initial value is an empty string
  const [message, setMessage] = useState({ text: "", color: "" });
  const [userNameAvailability, setUserNameAvailability] = useState({
    text: "",
    color: "",
    available: true,
  });
  const [verificationMessage, setVerificationMessage] = useState({
    text: "",
    color: "",
  });
  const [isUsernameAvailable, setIsUsernameAvailable] = useState(true);
  const [verificationCode, setVerificationCode] = useState("");
  const [showTwoFAModal, setShowTwoFAModal] = useState(false);
  const [twoFACode, setTwoFACode] = useState("");
  const [twoFAError, setTwoFAError] = useState("");
  const [showInfoModal, setShowInfoModal] = useState(null);
  const [termsChecked, setTermsChecked] = useState(false);
  const emailLinkForChangingPassword = () => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setMessage({ text: "PLease enter a valid email address", color: "red" });
      return;
    }

    // Construct the data object to send
    const formData = { email };

    // Send the data using Fetch API
    fetch(`${baseUrl}/php/sendLinkForChangingPassword.php`, {
      method: "POST",
      credentials: "same-origin", // Include credentials (cookies) in the request
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(async (response) => {
        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.error || "Unknown error occurred");
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setMessage({
            text: "Reset link has been sent to your Inbox.\nPlease check Spam folder if not found.",
            color: "green",
          });
        } else {
          setMessage({ text: data.error, color: "red" });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setMessage({ text: error.message, color: "red" });
      });
  };

  const verifyTFA = async () => {
    if (!twoFACode || twoFACode.length !== 6) {
      setTwoFAError("Please enter a valid 6-digit code.");
      return;
    }

    try {
      const response = await fetch("/php/TwoFA_verification.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ code: twoFACode }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.success) {
        setUser(data.user);
        setAuth(true);
        setTimeout(() => setShowTwoFAModal(false), 400);
      } else {
        setTwoFAError(data.message || "Invalid 2FA code. Please try again.");
      }
    } catch (error) {
      console.error("Error during 2FA verification:", error);
      setTwoFAError(
        "An error occurred while verifying the 2FA code. Please try again later."
      );
    }
  };

  

 const handleSignUp = async () => {
  setVerificationMessage({ text: "", color: "" });
  setVerificationCode("");

  if (!camp || !sectorUnit || !hutNumber) {
    setUserNameAvailability({
      text: "Camp, Sector, and Hut Number are required",
      color: "red",
    });
    return;
  }

  if (!signUpPassword || !retypedPassword) {
    setUserNameAvailability({
      text: "Password fields are required",
      color: "red",
    });
    return;
  }

  if (signUpPassword !== retypedPassword) {
    setUserNameAvailability({
      text: "Passwords do not match",
      color: "red",
    });
    return;
  }

  if (!signUpEmail) {
    setUserNameAvailability({ text: "Email is required", color: "red" });
    return;
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(signUpEmail)) {
    setUserNameAvailability({ text: "Invalid email format", color: "red" });
    return;
  }

  if (!country) {
    setUserNameAvailability({ text: "Country is required", color: "red" });
    return;
  }

  if (!termsChecked) {
    setUserNameAvailability({
      text: "Please accept terms",
      color: "red",
    });
    return;
  }

  const payload = {
    fullName: generatedFullName,
    username: generatedUsername, // base only
    password: signUpPassword,
    email: signUpEmail,
    country: country,
  };

  try {
    const response = await fetch(`${baseUrl}/php/signUp.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (data.success) {
      setUserNameAvailability({
        text: `Account created as ${data.username}`,
        color: "green",
      });

      setShowSignUp(false);
      setShowVerify(true);
      return;
    }

    // 🔴 Handle errors cleanly
    if (data.invalidCountry) {
      setUserNameAvailability({ text: "Invalid country", color: "red" });
    } else if (data.invalidName) {
      setUserNameAvailability({ text: "Invalid identity", color: "red" });
    } else if (data.emailAvailable === false) {
      setUserNameAvailability({
        text: "Email already registered",
        color: "red",
      });
    } else if (data.usernameAvailable === false) {
      setUserNameAvailability({
        text: data.reason || "Username unavailable",
        color: "red",
      });
    } else {
      setUserNameAvailability({
        text: data.message || "Signup failed",
        color: "red",
      });
    }

  } catch (error) {
    console.error(error);
    setUserNameAvailability({
      text: "Signup failed. Try again.",
      color: "red",
    });
  }
};

  const verifyEmail = () => {
    const formData = new FormData();
    formData.append("enteredCode", verificationCode);
    formData.append("email", signUpEmail);

    fetch(`${baseUrl}/php/verifyEmail.php`, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          setVerificationCode("");
          setEmail(signUpEmail);
          setShowVerify(false);
          setShowLogin(true);
          setMessage({ text: data.message, color: "green" });
        } else {
          setVerificationMessage({ text: data.message, color: "red" });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    if (globalState.user?.username) {
      let path = null;
      if (globalState.goTo === "following") {
        path = "/following";
      } else if (globalState.goTo === "profile") {
        path = `/@${globalState.user.username}`;
      }
      if (path) {
        navigate(path);
      }
    }
  }, [globalState.user, globalState.goTo, navigate]);
  const timeoutIdRef = useRef(null);

  const generatedUsername =
    camp && sectorUnit && hutNumber
      ? `${camp.replace(/\s+/g, "").toLowerCase()}-${sectorUnit.toUpperCase()}-${hutNumber}`
      : "";

  const generatedFullName =
    camp && sectorUnit && hutNumber
      ? `${camp} ${sectorUnit.toUpperCase()} ${hutNumber}`
      : "";

  const handleLogin = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }

    try {
      const loginData = new FormData();
      loginData.append("email", email);
      loginData.append("password", password);

      const response = await fetch(`${baseUrl}/php/login.php`, {
        method: "POST",
        body: loginData,
      });

      const data = await response.json();

      if (data.banned) {
        setMessage({
          text: data.message || "You are banned from using this account.",
          color: "red",
        });
      } else if (data.success) {
        if (data.TwoFA || data.needs_2FA) {
          setShowLogin(false);
          showAnotherSignInModal(false);
          setShowTwoFAModal(true);
        } else {
          // BATCH UPDATES: Update everything in one render cycle
          setGlobalState((prev) => ({
            ...prev,
            user: data.user,
            isAuthenticated: true,
            anotherSignInModal: false,
            sessionExpired: false,
            // Keeping showLogin: true if that's your preferred default behavior, 
            // but ensure it's not causing a visual flicker.
          }));

          setMessage({ text: "Login successful!", color: "green" });

          // Close the container
          setTimeout(() => onClose(), 400);
        }
      } else {
        const initialErrorMessage = data.message || "Login failed, please check your credentials.";

        setMessage({
          text: initialErrorMessage,
          color: "red",
        });
        if (initialErrorMessage === "Invalid email or password.") {
          timeoutIdRef.current = setTimeout(() => {
            setMessage({
              text: "Please Try Again",
              color: "red", // Keep the color red
            });
            timeoutIdRef.current = null; // Clear the ref after timeout fires
          }, 2000);
        }
      }
    } catch (error) {
      console.error("Login Error:", error);
      setMessage({
        text: "An error occurred during login. Please try again later.",
        color: "red",
      });
    } finally {
      setIsLoading(false);
    }
  };


  const isMobile =
    /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  if (!isOpen) return null;

  return (
    <>
      {showInfoModal && (
        <Information
          type={showInfoModal}
          onClose={() => setShowInfoModal(null)}
        />
      )}{" "}
      {showTwoFAModal && (
        <div id="TwoFA_modal" className="recovery_popup">
          <span className="closeLink" onClick={() => setShowTwoFAModal(false)}>
            &times;
          </span>
          <br />
          <div style={{ marginTop: "10px", color: "red" }}>
            {twoFAError && twoFAError}
          </div>
          <h2>Two-Factor Authentication</h2>
          <p>Please enter the 6-digit code sent to your email:</p>
          <input
            className="fullTextbox"
            placeholder="Enter 6-digit code"
            maxLength="6"
            autoComplete="off"
            value={twoFACode}
            onChange={(e) => setTwoFACode(e.target.value)}
          />
          <br />
          <button
            style={{ backgroundColor: "#3DDC84" }}
            className="confirm"
            onClick={verifyTFA}
          >
            Verify
          </button>
        </div>
      )}
      <div id="id02" className="w3-modal" style={{ display: "block" }}>
        <div className="modal-container">
          {globalState.showLogin && (
            <div
              id="login_modal"
              className="w3-modal-content-logIn w3-animate-bottom"
            >
              <header className="w3-container w3-teal">
                <div className="toggle_row">
                  <div
                    className="columnA"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "25px",
                    }}
                  >
                    <span style={{ fontSize: "20px", marginLeft: "5px" }}>
                      Log In
                    </span>
                    <span
                      onClick={onClose}
                      style={{
                        fontSize: "40px",
                        cursor: "pointer",
                        marginTop: isMobile ? "-7.5px" : "0px",
                      }}
                    >
                      ×
                    </span>
                  </div>
                </div>
              </header>
              <form onSubmit={handleLogin}>
                {/* Username availability message above the form */}
                {message.text && (
                  <div
                    id="username_availability"
                    style={{
                      color: message.color,
                      margin: "7px auto 0 auto",
                      textAlign: "center",
                    }}
                  >
                    {message.text}
                  </div>
                )}

                <div className="logInTextContainer">
                  <div>
                    <input
                      className="full_textbox"
                      type="email"
                      placeholder="Email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      autoComplete="email"
                    />
                  </div>
                  <div>
                    <input
                      type="password"
                      placeholder="Password"
                      name="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      autoComplete="current-password"
                    />
                    <span
                      id="resetPassword"
                      onClick={() => {
                        const emailInput = document.getElementById("userid");
                        if (!emailInput.checkValidity()) {
                          emailInput.reportValidity();
                          return;
                        }
                        emailLinkForChangingPassword();
                      }}
                      style={{
                        fontSize: "15px",
                        marginTop: "11px",
                        cursor: "pointer",
                        width: "90px",
                      }}
                    >
                      Reset Password
                    </span>
                  </div>
                </div>

                <div className="centered-buttons">
                  <button
                    type="submit"
                    style={{ color: "white", backgroundColor: "blue" }}
                    disabled={isLoading}
                  >
                    {isLoading ? "Logging In..." : "Log In"}
                  </button>
                  <button
                    type="button"
                    style={{ color: "black", backgroundColor: "#3DDC84" }}
                    onClick={() => {
                      setShowLogin(false);
                      setShowSignUp(true);
                    }}
                  >
                    Sign Up
                  </button>
                </div>
              </form>
            </div>
          )}
          {globalState.showSignUp && (
            <div
              id="signUp_modal"
              className="w3-modal-content-logIn w3-animate-bottom"
            >
              <header className="w3-container w3-teal">
                <div className="toggle_row">
                  <div
                    className="columnA"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "25px",
                    }}
                  >
                    <span style={{ fontSize: "20px", marginLeft: "5px" }}>
                      Sign Up
                    </span>
                    <span
                      onClick={onClose}
                      style={{
                        fontSize: "40px",
                        cursor: "pointer",
                        marginTop: isMobile ? "-7.5px" : "0px",
                      }}
                    >
                      ×
                    </span>
                  </div>
                </div>
              </header>
              <div className="w3-container">
                <div className="signUpTextContainer">
                  {userNameAvailability.text && (
                    <div
                      style={{
                        color: userNameAvailability.color,
                        textAlign: "center",
                        marginTop: "5px",
                      }}
                    >
                      {userNameAvailability.text}
                    </div>
                  )}
                 <div className="identity-row">
  <select
    className="full_textbox"
    value={camp}
    onChange={(e) => setCamp(e.target.value)}
  >
    <option value="">Camp</option>
    <option>Beldangi 1</option>
    <option>Beldangi 2</option>
    <option>Beldangi 3</option>
    <option>Pathri</option>
    <option>Goldhap</option>
    <option>Temai</option>
    <option>Khudunabari</option>
  </select>

<input
  className="full_textbox identity-small"
  type="text"
  placeholder="Sector (e.g. F2)"
  value={sectorUnit}
  maxLength="4"
  onChange={(e) => {
    let val = e.target.value.toUpperCase();

    // enforce: LETTER + NUMBER
    val = val.replace(/[^A-Z0-9]/g, "");

    // force first char letter, rest numbers
    if (val.length > 0) {
      val =
        val[0].replace(/[^A-Z]/g, "") +
        val.slice(1).replace(/[^0-9]/g, "");
    }

    setSectorUnit(val);
  }}
/>

  <input
    className="full_textbox identity-medium"
    type="number"
    placeholder="Hut #"
    value={hutNumber}
    onChange={(e) => setHutNumber(e.target.value.replace(/\D/g, ""))}
  />
</div>
                  <input
                    type="password"
                    placeholder="Create a Password"
                    value={signUpPassword}
                    onChange={(e) => setSignUpPassword(e.target.value)}
                    autoComplete="off"
                  />
                  <input
                    type="password"
                    placeholder="Retype Password"
                    value={retypedPassword}
                    onChange={(e) => setRetypedPassword(e.target.value)}
                    autoComplete="off"
                  />
                  <input
                    type="email"
                    placeholder="Email"
                    value={signUpEmail}
                    onChange={(e) => setSignUpEmail(e.target.value)}
                    autoComplete="off"
                  />
                  <input
                    type="text"
                    placeholder="Family Name"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    autoComplete="off"
                  />
                  <div
                    style={{
                      float: "left",
                      margin: "25px 10px",
                      fontSize: "14px",
                      lineHeight: "1.3",
                      maxWidth: "calc(100% - 40px)",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="termsCheckbox"
                      name="termsCheckbox"
                      autoComplete="off"
                      checked={termsChecked}
                      onChange={(e) => setTermsChecked(e.target.checked)}
                    />
                    <label
                      htmlFor="termsCheckbox"
                      style={{ marginLeft: "6px" }}
                    >
                      I confirm I'm 13 or older and agree to the{" "}
                      <span
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowInfoModal("terms_and_conditions")}
                      >
                        Terms, Conditions
                      </span>
                      , and{" "}
                      <span
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => setShowInfoModal("privacy_policy")}
                      >
                        Privacy Policy
                      </span>
                      .
                    </label>
                  </div>
                  <div className="centered-buttons">
                    <button
                      onClick={handleSignUp}
                      id="signUpButton"
                      style={{
                        color: "black",
                        backgroundColor: "#3DDC84",
                        margin: "5px",
                      }}
                    >
                      Sign Up
                    </button>
                    <button
                      onClick={() => {
                        setShowSignUp(false);
                        setShowLogin(true);
                      }}
                      style={{
                        color: "black",
                        backgroundColor: "lightred",
                        margin: "5px",
                      }}
                    >
                      Back to Login
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {globalState.showVerify && (
            <div
              id="login_modal"
              className="w3-modal-content-logIn w3-animate-bottom"
            >
              <header className="w3-container w3-teal">
                <div className="toggle_row">
                  <div
                    className="columnA"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "25px",
                    }}
                  >
                    <span style={{ fontSize: "20px", marginLeft: "5px" }}>
                      Sign Up
                    </span>
                    <span
                      onClick={onClose}
                      style={{
                        fontSize: "40px",
                        cursor: "pointer",
                        marginTop: isMobile ? "-7.5px" : "0px",
                      }}
                    >
                      ×
                    </span>
                  </div>
                </div>
              </header>
              <h4 style={{ margin: "15px 5px 10px 5px" }}>
                Enter the six digit code sent to {signUpEmail}. Please check Spam folder if not found.
              </h4>
              <form id="verifyEmailForm">
                {/* Username availability message above the form */}
                {verificationMessage.text && (
                  <div
                    style={{
                      color: message.color,
                      margin: "10px",
                      textAlign: "center",
                    }}
                  >
                    {verificationMessage.text}
                  </div>
                )}

                <div className="logInTextContainer">
                  <div>
                    <input
                      className="fullTextbox"
                      placeholder="Enter The Code Here"
                      value={verificationCode}
                      onChange={(e) => setVerificationCode(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="centered-buttons">
                  <button
                    type="button"
                    onClick={verifyEmail}
                    id="verify_button"
                    style={{ color: "white", backgroundColor: "#3DDC84" }}
                  >
                    Verify
                  </button>
                  <button
                    type="button"
                    id="sign_up_button"
                    style={{ color: "black", backgroundColor: "blue" }}
                    onClick={() => {
                      setShowVerify(false);
                      setShowSignUp(true);
                    }}
                  >
                    Back To Sign Up
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LoginModal;
